import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '~utils/Classes';

export interface ILoyaltyTierDiamond {
    loyaltyTier?: number;
    sign?: string;
    size?: string;
    textColor: string;
}

const BenefitsRewardsTableWrapperDot = styled.div<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableWrraperDot;
`;

const BenefitsRewardsTableWrapperDotTransform = styled.div`
    transform: rotate(-45deg);
`;

const BenefitsRewardsTableWrapperDotBronze = styled.div<{ size?: string }>`
    grid-area: benefitsRewardsTableWrraperDot;
    background-color: #bc8888;
    border-top: ${({ size }) => (size ? size : '6px')} solid #ac7171;
    border-right: ${({ size }) => (size ? size : '6px')} solid #935555;
    border-bottom: ${({ size }) => (size ? size : '6px')} solid #a36868;
    border-left: ${({ size }) => (size ? size : '6px')} solid #c18b8b;
`;
const BenefitsRewardsTableWrapperDotSilver = styled.div<{ size?: string }>`
    grid-area: benefitsRewardsTableWrraperDot;
    background-color: #a1a1a1;
    border-top: ${({ size }) => (size ? size : '6px')} solid #a1a1a1;
    border-right: ${({ size }) => (size ? size : '6px')} solid #959595;
    border-bottom: ${({ size }) => (size ? size : '6px')} solid #b4b4b4;
    border-left: ${({ size }) => (size ? size : '6px')} solid #bdbdbd;
`;
const BenefitsRewardsTableWrapperDotGold = styled.div<{ size?: string }>`
    grid-area: benefitsRewardsTableWrraperDot;
    background-color: #96783d;
    border-top: ${({ size }) => (size ? size : '6px')} solid #96783d;
    border-right: ${({ size }) => (size ? size : '6px')} solid #8e6e33;
    border-bottom: ${({ size }) => (size ? size : '6px')} solid #ab853e;
    border-left: ${({ size }) => (size ? size : '6px')} solid #c29b4e;
`;

const BenefitsRewardsTableWrapperDotPlatinum = styled.div<{ size?: string }>`
    grid-area: benefitsRewardsTableWrraperDot;
    background-color: #8fb5cd;
    border-top: ${({ size }) => (size ? size : '6px')} solid #8fb5cd;
    border-right: ${({ size }) => (size ? size : '6px')} solid #7b9bae;
    border-bottom: ${({ size }) => (size ? size : '6px')} solid #7092a8;
    border-left: ${({ size }) => (size ? size : '6px')} solid #83abc6;
`;

const benefitsRewardsTableWrapperDotClass = classes(
    'loyalty-marketing-page-benefits-rewards__table__dot',
    'elc-loyalty-marketing-page-benefits-rewards__table__diamond'
);
const tierInfoWrapperClass = classes('loyalty-tier-diamond-wrapper');
export const TEST_ID_LOYALTY_TIER_DIAMOND = 'loyalty-tier-diamond';

export const LoyaltyTierDiamond = observer(function LoyaltyTierDiamond({
    loyaltyTier,
    textColor,
    size
}: ILoyaltyTierDiamond) {
    const getDiamond = (tier: number) => {
        switch (tier) {
            case 1:
                return (
                    <BenefitsRewardsTableWrapperDotBronze
                        className={benefitsRewardsTableWrapperDotClass}
                        size={size}
                    ></BenefitsRewardsTableWrapperDotBronze>
                );
            case 2:
                return (
                    <BenefitsRewardsTableWrapperDotSilver
                        className={benefitsRewardsTableWrapperDotClass}
                        size={size}
                    ></BenefitsRewardsTableWrapperDotSilver>
                );
            case 3:
                return (
                    <BenefitsRewardsTableWrapperDotGold
                        className={benefitsRewardsTableWrapperDotClass}
                        size={size}
                    ></BenefitsRewardsTableWrapperDotGold>
                );
            case 4:
                return (
                    <BenefitsRewardsTableWrapperDotPlatinum
                        className={benefitsRewardsTableWrapperDotClass}
                        size={size}
                    ></BenefitsRewardsTableWrapperDotPlatinum>
                );
            default:
                return (
                    <BenefitsRewardsTableWrapperDot
                        className={benefitsRewardsTableWrapperDotClass}
                        textColor={textColor}
                    ></BenefitsRewardsTableWrapperDot>
                );
        }
    };

    const lt = loyaltyTier ? loyaltyTier : 0;

    return (
        <div className={tierInfoWrapperClass} data-test-id={TEST_ID_LOYALTY_TIER_DIAMOND}>
            <BenefitsRewardsTableWrapperDotTransform>
                {getDiamond(lt)}
            </BenefitsRewardsTableWrapperDotTransform>
        </div>
    );
});
